import React from "react"
import { useTranslation } from "react-i18next"
import { Button, ModalFooter } from "reactstrap"
import { showAlert } from "store/reducers/alertReducer"
import { assetsDeliveryConfirmation } from "store/actions/authAction"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"

const UpdateBankDetails = ({ userDetails, toggleModal, getDetails, idCardReceived, uniformReceived }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const dispatch = useDispatch()
  const { isLoading } = useSelector(state => state.Login)

  const handleOnSubmit = () => {
    const payload = {
      user_uuid: userDetails?.user_information?.uuid,
      id_card_status: idCardReceived,
      uniform_status: uniformReceived,
    }
    dispatch(assetsDeliveryConfirmation(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          getDetails()
          toggleModal()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div className="col-lg-12">
      <p className="text-muted font-size-16 mb-4">

        { idCardReceived && userDetails?.user_information?.id_card_status === 1 && ("Are you sure you have received the ID card?")}
        { uniformReceived && userDetails?.user_information?.uniform_status === 1 && ("Are you sure you have received the Uniform?")}
      </p>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          {t("No")}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            handleOnSubmit()
          }}
          disabled={isLoading}
        >
          {t("Yes")}
        </Button>
      </ModalFooter>
    </div>
  )
}

export default UpdateBankDetails
